export const TREATMENT_SCOPES = {
  TOOTH: "tooth",
  ARCH: "arch",
  FULL: "full_mouth",
  ANY: "any",
};

export const SCOPE_ORDER = [
  TREATMENT_SCOPES.FULL,
  TREATMENT_SCOPES.ARCH,
  TREATMENT_SCOPES.TOOTH,
];

export const normalizeScope = (scope, tooth) => {
  if (
    scope === TREATMENT_SCOPES.TOOTH ||
    scope === TREATMENT_SCOPES.ARCH ||
    scope === TREATMENT_SCOPES.FULL
  ) {
    return scope;
  }
  if (scope === "upper_arch" || scope === "lower_arch") {
    return TREATMENT_SCOPES.ARCH;
  }
  if (tooth) return TREATMENT_SCOPES.TOOTH;
  return TREATMENT_SCOPES.FULL;
};

export const normalizeServiceScope = (scope) => {
  if (
    scope === TREATMENT_SCOPES.TOOTH ||
    scope === TREATMENT_SCOPES.ARCH ||
    scope === TREATMENT_SCOPES.FULL ||
    scope === TREATMENT_SCOPES.ANY
  ) {
    return scope;
  }
  if (scope === "upper_arch" || scope === "lower_arch") {
    return TREATMENT_SCOPES.ARCH;
  }
  return TREATMENT_SCOPES.TOOTH;
};

export const getScopeLabel = (scope, tooth) => {
  const normalized = normalizeScope(scope, tooth);
  if (normalized === TREATMENT_SCOPES.ARCH) return "Arcada";
  if (normalized === TREATMENT_SCOPES.FULL) return "Globala";
  return tooth ? `Dinte ${tooth}` : "Dinte";
};

export const getScopeKey = (scope, tooth) => {
  const normalized = normalizeScope(scope, tooth);
  if (normalized === TREATMENT_SCOPES.TOOTH) {
    return `tooth:${tooth || ""}`;
  }
  return normalized;
};

export const isServiceScopeAllowed = (serviceScope, targetScope) => {
  const normalizedService = normalizeServiceScope(serviceScope);
  if (normalizedService === TREATMENT_SCOPES.ANY) return true;
  return normalizedService === normalizeScope(targetScope);
};

export const getScopeOrder = (scope, tooth) => {
  const normalized = normalizeScope(scope, tooth);
  const index = SCOPE_ORDER.indexOf(normalized);
  return index === -1 ? SCOPE_ORDER.length : index;
};
